var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_2481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 13.9996H14.7096L14.4296 13.7296C15.6296 12.3296 16.2496 10.4196 15.9096 8.38965C15.4396 5.60965 13.1196 3.38965 10.3196 3.04965C6.08965 2.52965 2.52965 6.08965 3.04965 10.3196C3.38965 13.1196 5.60965 15.4396 8.38965 15.9096C10.4196 16.2496 12.3296 15.6296 13.7296 14.4296L13.9996 14.7096V15.4996L18.2496 19.7496C18.6596 20.1596 19.3296 20.1596 19.7396 19.7496C20.1496 19.3396 20.1496 18.6696 19.7396 18.2596L15.4996 13.9996ZM9.49965 13.9996C7.00965 13.9996 4.99965 11.9896 4.99965 9.49965C4.99965 7.00965 7.00965 4.99965 9.49965 4.99965C11.9896 4.99965 13.9996 7.00965 13.9996 9.49965C13.9996 11.9896 11.9896 13.9996 9.49965 13.9996Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_2481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.d520350b80b93b165d77d26e13c164cd.svg";
export { ForwardRef as ReactComponent };